export default class TripAdvisorReview {
  static fromJSON(json) {
    return new TripAdvisorReview({
      description: json.description,
      hotelResponse: json.hotelResponse,
      publicationDate: json.publicationDate,
      rating: json.rating,
      title: json.title,
      traveler: json.traveler,
      travelerSubRatings: json.travelerSubRatings
    })
  }

  constructor({
    description,
    hotelResponse,
    publicationDate,
    rating,
    title,
    traveler,
    travelerSubRatings
  }) {
    this.description = description
    this.hotelResponse = hotelResponse
    this.publicationDate = publicationDate
    this.rating = rating
    this.title = title
    this.traveler = traveler
    this.travelerSubRatings = travelerSubRatings
  }
}
